const l=({isMagaluBrand:l,itemOffer:o})=>{var r,e;return l?"0":`1:${(null===(e=null===(r=null==o?void 0:o.seller)||void 0===r?void 0:r.stats)||void 0===e?void 0:e.score)||null}`};export{l as buildDimension23};
